<template>
  <div class="steps-wrapper">
    <div
      class="step"
      v-for="(step, index) in getSteps()"
      :key="index"
      :class="[
        { 'step-active': step.active },
        step.milestone ? 'big-step' : 'base-step',
      ]"
    >
      <div>
        <div
          v-if="step.milestone"
          class="milestone"
          :class="{
            'bg-warning': step.completed,
            'bg-info': step.edge,
            end: step.end,
          }"
        >
          <i
            v-if="step.completed"
            :class="['fa', step.icon ? step.icon : 'fa-check']"
          ></i>
          <i v-else-if="step.icon" :class="['fa', step.icon]"></i>
          <span v-else>{{ step.number }}</span>
        </div>
        <div
          v-else
          class="circle"
          :class="{ 'bg-success': step.completed }"
        ></div>
      </div>
      <div :class="{ 'step-completed': step.completed }">
        <div class="title" @click="modals.submit = true">
          {{ step.title }}
          <span
            class="btn btn-sm btn-custom btn-white date-completed float-right"
            v-if="step.completed && step.date"
            >Completo em {{ step.date }}</span
          >
          <span
            class="btn btn-sm btn-custom btn-danger deadline"
            v-if="!step.completed && step.date"
            >Até {{ step.date }}</span
          >
        </div>
        <div v-if="step.caption" class="caption text-muted">
          {{ step.caption }}
        </div>
      </div>
    </div>
    <modal :show.sync="modals.submit" modal-classes="modal-dialog-centered">
      <div class="modal-title">
        <h5 slot="header" id="modal-title-notification">Equipe completa</h5>
        <div class="row text-center">
          <div class="col-12">
            <a href="#" class="btn btn-info text-right">How to</a>
          </div>
        </div>
      </div>
      <div class="modal-body">
        <div class="py-1">
          <div class="row">
            <div class="col-lg-12">
              <base-input label="Complementariedade">
                <textarea
                  rows="3"
                  class="form-control"
                  placeholder="Digite aqui..."
                >
                </textarea>
              </base-input>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <base-input label="Multidisciplinaridade">
                <textarea
                  rows="3"
                  class="form-control"
                  placeholder="Digite aqui..."
                >
                </textarea>
              </base-input>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <base-input label="Arquivo complementar (opcional)">
                <input type="file" class="form-control" />
              </base-input>
            </div>
          </div>
        </div>
      </div>
      <template slot="footer">
        <base-button type="link" class="ml-auto" @click="modals.submit = false">
          Voltar
        </base-button>
        <base-button type="white" @click="modals.submit = false">
          Realizar submissão
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
export default {
  name: "steps",
  props: {
    fase: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      steps1: [
        {
          title: "Início da Pré-aceleração STARS",
          caption: "21 de novembro de 2019",
          number: 0,
          icon: "fa fa-rocket",
          milestone: true,
          edge: true,
        },
        {
          title: "Equipe Complementar",
          date: "25/11/2019",
          caption:
            "Ter um time alinhado, com multidisciplinariedade e experiências, é a chave para que todos os demais processos se desenvolvam com excelência",
          number: 1,
          completed: true,
          milestone: true,
        },
        {
          title: "Multidisciplinaridade",
          number: 1.1,
          completed: true,
        },
        {
          title: "Experiência empreendedora",
          number: 1.2,
          completed: true,
        },
        {
          title: "Skills",
          number: 1.3,
          completed: true,
        },
        {
          title: "Conhecimentos voltados ao empreendimento",
          number: 1.4,
          completed: true,
        },
        {
          title: "Dedicação da Equipe",
          number: 1.5,
          completed: true,
        },
        {
          title: "Desenvolvimento da ideia",
          date: "10/12/2019",
          caption:
            "Houston, we have a problem?! Questionamentos que devem ser realizados no momento do nascimento de uma ideia",
          number: 2,
          completed: true,
          milestone: true,
        },
        {
          title: "Qual a dor que será sanada?",
          number: 2.1,
          completed: true,
        },
        {
          title: "O que sabem sobre o problema?",
          number: 2.2,
          completed: true,
        },
        {
          title: "O que levaram em consideração que ninguém mais pensou?",
          number: 2.3,
          completed: true,
        },
        {
          title: "Qual será o valor que irá guiar a solução do problema?",
          number: 2.4,
          completed: true,
        },
        {
          title: "Foto do time em momento de Brainstorming",
          number: 2.5,
          completed: true,
        },
        {
          title: "Construção do MVP",
          date: "25/12/2019",
          caption: "Mínimo Produto Viável",
          number: 3,
          completed: true,
          milestone: true,
        },
        {
          title: "Definição de Persona",
          date: "25/12/2019",
          caption:
            '"O cliente ideal". É saber quem é a pessoa que se interessa pelo seu produto. É como um público-alvo, mas vai além disso. Ela vê o cliente de forma mais personalizada e humanizada, extraindo características, preferências e rotinas. ',
          number: 4,
          completed: true,
          milestone: true,
        },
        {
          title: "Quem é o seu potencial cliente (buyer persona)?",
          number: 4.1,
          completed: true,
        },
        {
          title: "Quais são as atividades mais comuns que ele realiza?",
          number: 4.2,
          completed: true,
        },
        {
          title: "Que tipo de informações ele consome e em quais veículos?",
          number: 4.3,
          completed: true,
        },
        {
          title: "Quem o influencia?",
          number: 4.4,
          completed: true,
        },
        {
          title: "Onde ele busca informações?",
          number: 4.5,
          completed: true,
        },
        {
          title: "Que tipo de assunto interessaria a ele sobre o seu setor?",
          number: 4.6,
          completed: true,
        },
        {
          title: "Quais são os critérios de decisão na hora da compra?",
          number: 4.7,
          completed: true,
        },
        {
          title: "Quais os problemas e anseios dessa pessoa?",
          number: 4.8,
          completed: true,
        },
        {
          title: "Quais os valores dessa pessoa?",
          number: 4.9,
          completed: true,
        },
        {
          title: "Quais as vaidades dessa pessoa?",
          number: "4.10",
          completed: true,
        },
        {
          title: "Análise de mercado",
          date: "10/01/2020",
          caption:
            "Que tipo de mar é esse?! A análise de viabilidade de mercado é um estudo financeiro que determina as possibilidades econômicas e financeiras de um determinado projeto de produto ou serviço.",
          number: 5,
          completed: true,
          milestone: true,
        },
        {
          title: "Qual o setor e contexto (ambiente interno e externo)?",
          number: 5.1,
          completed: true,
        },
        {
          title: "Quem constitui o mercado?",
          number: 5.2,
          completed: true,
        },
        {
          title: "Tamanho de mercado",
          number: 5.3,
          completed: true,
        },
        {
          title: "Concorrência regional e global",
          number: 5.4,
          completed: true,
        },
        {
          title: "Principais concorrentes (diretos e indiretos)",
          number: 5.5,
          completed: true,
        },

        {
          title:
            "Qual a participação de mercado entre os principais concorrentes?",
          number: 5.6,
          completed: true,
        },
        {
          title: "Fornecedores",
          number: 5.7,
          completed: true,
        },
        {
          title: "Fim da primeira fase",
          caption: "22 de fevereiro de 2020",
          number: 0,
          milestone: true,
          edge: true,
          end: true,
          icon: "fa fa-flag-checkered",
        },
      ],
      steps2: [
        {
          title: "Segunda fase da Pré-aceleração STARS",
          caption: "01 de março de 2020",
          number: 0,
          icon: "fa fa-rocket",
          milestone: true,
          edge: true,
        },
        {
          title: "Vantagens competitivas",
          date: "12/02/2020",
          caption:
            "É o destaque que a startup terá de seus concorrentes. Esses diferenciais podem ser em custos, um novidade para o mercado, a solução de um problema com diferentes maneiras, entre outros. ",
          number: 6,
          completed: true,
          milestone: true,
        },
        {
          title: "Qual seu diferencial?",
          number: 6.1,
          completed: true,
        },
        {
          title: "Funil de vendas",
          date: "29/01/2010",
          caption:
            "Colocar o cliente em primeiro lugar fornece o foco e a priorização necessária para mover cada startup para o próximo nível. Aqui indetificam-se as fases da jornada de compras em estágios, observando os gatilhos que fazem o cliente cair no funil. É uma ferramenta útil para saber onde devem ser concentrados os esforços de marketing e vendas. ",
          number: 7,
          completed: true,
          milestone: true,
        },
        {
          title: "ToFu",
          number: 7.1,
          completed: true,
        },
        {
          title: "MoFu",
          number: 7.2,
          completed: true,
        },
        {
          title: "BoFu",
          number: 7.3,
          completed: true,
        },
        {
          title: "Atrair",
          number: 7.4,
          completed: true,
        },
        {
          title: "Converter",
          number: 7.5,
          completed: true,
        },
        {
          title: "Fechar",
          number: 7.6,
          completed: true,
        },
        {
          title: "Fidelizar",
          number: 7.7,
          completed: true,
        },
        {
          title: "Definiçao de público alvo",
          date: "27/02/2020",
          caption:
            "Para quem? Após ter definido quem é a Persona que seu negócio atinge, é momento de ampliar o campo de atuação. Assim, define-se o Público Alvo.",
          number: 8,
          completed: true,
          milestone: true,
        },
        {
          title: "Hora da pesquisa: Qual o público alvo?",
          number: 8.1,
          completed: true,
        },
        {
          title: "Definição dos canais de distribuição",
          date: "04/03/2020",
          caption: "Como seu produto/serviço chegará até o cliente?",
          number: 9,
          completed: true,
          milestone: true,
        },
        {
          title: "Modo de distribuição",
          number: 9.1,
          completed: true,
        },
        {
          title: "Canais de Marketing",
          number: 9.2,
          completed: true,
        },
        {
          title: "Construção de cenários",
          date: "18/01/2020",
          caption:
            "Construir cenários é agir no presente para edificar o futuro. Serve para possuir diferentes alternativas de caminhos, projetar o que pode acontecer para não ter surpresas indesejadas.",
          number: 10,
          completed: true,
          milestone: true,
        },
        {
          title: "PESTEL",
          number: 10.1,
          completed: true,
        },
        {
          title: "5 Forças de Porter",
          number: 10.2,
          completed: true,
        },
        {
          title: "Análise SWOT: Forças",
          number: 10.3,
          completed: true,
        },
        {
          title: "Análise SWOT: Fraquezas",
          number: 10.4,
          completed: true,
        },
        {
          title: "Análise SWOT: Oportunidades",
          number: 10.5,
          completed: true,
        },
        {
          title: "Análise SWOT: Ameaças",
          number: 10.6,
          completed: true,
        },
        {
          title: "Cenário: Desenvolvimento",
          number: 10.7,
          completed: true,
        },
        {
          title: "Cenário: Crescimento",
          number: 10.8,
          completed: true,
        },
        {
          title: "Cenário: Manutenção",
          number: 10.9,
          completed: true,
        },
        {
          title: "Cenário: Sobrevivência",
          number: "10.10",
          completed: true,
        },
        {
          title: "Fim da segunda fase",
          caption: "22 de fevereiro de 2020",
          number: 0,
          milestone: true,
          edge: true,
          end: true,
          icon: "fa fa-flag-checkered",
        },
      ],
      steps3: [
        {
          title: "Terceira fase da Pré-aceleração STARS",
          caption: "01 de março de 2020",
          number: 0,
          icon: "fa fa-rocket",
          milestone: true,
          edge: true,
        },
        {
          title: "Precificação",
          date: "22/02/2020",
          caption:
            "Não é apenas o preço que o produto/serviço possui, mas sim o valor que estará envolvido nele. Sendo assim, leva em conta um conjunto de fatores qualitativos dados ao produto pelo próprio consumidor – como status, qualidade, necessidade, inovação, e exclusividade.",
          number: 11,
          completed: true,
          milestone: true,
        },
        {
          title: "Custo de produto",
          number: 11.1,
          completed: true,
        },
        {
          title: "Custos de operação",
          number: 11.2,
          completed: true,
        },
        {
          title: "Custo de trabalho",
          number: 11.3,
          completed: true,
        },
        {
          title: "Impostos",
          number: 11.4,
          completed: true,
        },
        {
          title: "Margem de lucro pretendida",
          number: 11.5,
          completed: true,
        },
        {
          title: "Métodos de precificação: baseado no custo",
          number: 11.6,
          completed: true,
        },
        {
          title: "Métodos de precificação: baseado no valor percebido",
          number: 11.7,
          completed: true,
        },
        {
          title: "Métodos de precificação: baseado na concorrência",
          number: 11.8,
          completed: true,
        },
        {
          title: "Testes de MVP",
          date: "22/02/2020",
          caption: "Como encontra-se o desenvolvimento do MVP?",
          number: 12,
          milestone: true,
          completed: true,
        },
        {
          title: "Quantos testes já foram realizados? ",
          number: 12.1,
          completed: true,
        },
        {
          title: "Quantas adaptações do MVP ja aconteceram?",
          number: 12.2,
          completed: true,
        },
        {
          title: "Business Plan",
          date: "22/02/2020",
          caption: "Planejamento empresarial",
          number: 13,
          milestone: true,
          completed: true,
        },
        {
          title: "Sumário executivo",
          number: 13.1,
          completed: true,
        },
        {
          title: "Planejamento estratégico do negócio",
          number: 13.2,
          completed: true,
        },
        {
          title: "Plano de marketing",
          number: 13.3,
          completed: true,
        },
        {
          title: "Plano financeiro e de investimento",
          number: 13.4,
          completed: true,
        },
        {
          title: "Bussines model",
          date: "22/02/2020",
          caption:
            "Após o desenvolvimento de todas as etapas anteriores, a startup está apta a preencher o quadro Canva para modelo de negócios, que será revisado durante o BootCamp junto da Stars Aceleradora. ",
          number: 14,
          completed: true,
          milestone: true,
        },
        {
          title: "Confecção plano",
          number: 14.1,
          completed: true,
        },
        {
          title: "Pitch",
          date: "22/02/2020",
          caption: "O tempo é curto!",
          number: 15,
          milestone: true,
          completed: true,
        },
        {
          title: "One-sentence pitch",
          number: 15.1,
          completed: true,
        },
        {
          title: "Elevator pitch",
          number: 15.2,
          completed: true,
        },
        {
          title: "Pitch deck",
          number: 15.3,
          completed: true,
        },
        {
          title: "Fim da terceira fase",
          caption: "22 de fevereiro de 2020",
          number: 0,
          edge: true,
          milestone: true,
          end: true,
          icon: "fa fa-flag-checkered",
        },
      ],
      steps4: [
        {
          title: "Quarta fase da Pré-aceleração STARS",
          caption: "01 de março de 2020",
          number: 0,
          icon: "fa fa-rocket",
          milestone: true,
          edge: true,
        },

        {
          title: "Parcerias estratégicas",
          caption:
            "Parcerias estratégicas potencializam o crescimento de sua startup. Ela pode ser estabelecida com outras empresas ou com apenas uma pessoa que proporcione auxílios, aportes, benchmarking, entre outros. ",
          number: 16,
          milestone: true,
          completed: true,
        },
        {
          title: "Clientes ativos",
          caption:
            "Número de clientes que a empresa adquire a cada mês. Um indicador muito importante para a avaliação do desempenho e crescimento de startups, conhecido como MAU, monthly active users. ",
          number: 17,
          milestone: true,
          completed: true,
        },
        {
          title: "DAU",
          number: 17.1,
          completed: true,
        },
        {
          title: "MAU",
          number: 27.2,
          completed: true,
        },
        {
          title: "Faturamento",
          caption:
            "Let's talk about money! Mesmo que pequeno, é importante saber se há um crescimento ou não.. também é uma forma de pensar melhorias.",
          number: 18,
          milestone: true,
          completed: true,
        },
        {
          title: "Feedback dos usuários",
          caption: "Como está a populariedade?",
          number: 19,
          milestone: true,
          completed: true,
        },
        {
          title: "Nuvem de palavras",
          number: 19.1,
          completed: true,
        },
        {
          title: "Net Promoter Score",
          caption:
            "Net Promoter Score, o quanto os clientes estão indicando sua empresa para os amigos? Em uma escala de 0 a 10 você descobre seus clientes promotores e detratores",
          number: 20,
          milestone: true,
          completed: true,
        },
        {
          title: "Desafios e barreiras vencidas",
          caption:
            "A quantidade de desafios que a startup vem vencendo com o passar do tempo demonstra o amadurecimento desta. ",
          number: 21,
          milestone: true,
          completed: true,
        },
        {
          title: "Contratações",
          caption:
            "Equipe crescendo é um sinal de que a empresa está crescendo também!",
          number: 22,
          milestone: true,
          completed: true,
        },
        {
          title: "Taxa de aprimoramento do produto",
          caption: "Feedbacks x alterações realizadas",
          number: 23,
          milestone: true,
          completed: true,
        },
        {
          title: "Valuation Estimado",
          caption: "Quanto vale sua startup?",
          number: 24,
          milestone: true,
          completed: true,
        },
        {
          title: "Estabelecimento de metas",
          caption: "E daqui pra frente?",
          number: 25,
          milestone: true,
          completed: true,
        },
        {
          title: "Esperado x real",
          number: 25.1,
          completed: true,
        },
        {
          title: "SMART",
          number: 25.2,
          completed: true,
        },
        {
          title: "Fim da quarta fase",
          caption: "22 de fevereiro de 2020",
          number: 0,
          milestone: true,
          edge: true,
          end: true,
          icon: "fa fa-flag-checkered",
        },
      ],
      bootcamp: [
        {
          title: "Almost there: Bootcamp STARS",
          caption: "01 de março de 2020",
          number: 0,
          icon: "fa fa-rocket",
          milestone: true,
          edge: true,
          end: true,
        },
      ],
      demoday: [
        {
          title: "Mission Accomplished: Demoday Stars",
          caption: "01 de março de 2020",
          number: 0,
          icon: "fa fa-rocket",
          milestone: true,
          edge: true,
          end: true,
        },
      ],
      modals: {
        submit: false,
      },
    };
  },
  methods: {
    getSteps() {
      if (this.fase === "steps1") return this.steps1;
      if (this.fase === "steps2") return this.steps2;
      if (this.fase === "steps3") return this.steps3;
      if (this.fase === "steps4") return this.steps4;
      if (this.fase === "bootcamp") return this.bootcamp;
      if (this.fase === "demoday") return this.demoday;
      return null;
    },
  },
};
</script>
<style scoped>
.date-completed,
.deadline {
  font-size: 11px;
  color: #333333;
  text-transform: uppercase;
  margin-left: 10px;
}
.deadline {
  color: #ffffff;
}
.steps-wrapper {
  font-size: 21px;
  font-family: Roboto;
  margin: 30px 30px;
}
/* Steps */
.step {
  position: relative;
  min-height: 1em;
  color: gray;
}
.step + .step {
  margin-top: 1.5em;
}
.step > div:first-child {
  position: static;
  height: 0;
}
.step > div:not(:first-child) {
  margin-left: 1.5em;
  padding-left: 1em;
}
.step.step-active {
  color: #4285f4;
}
.step.step-active .milestone,
.step.step-active .circle {
  background-color: #4285f4;
}

/* Circle */
.circle {
  background: gray;
  position: relative;
  width: 0.5em;
  height: 0.5em;
  left: 0.5em;
  line-height: 0.5em;
  border-radius: 100%;
  color: #fff;
  text-align: center;
  box-shadow: 0 0 0 3px #fff;
}

.milestone {
  background: gray;
  position: relative;
  width: 1.5em;
  height: 1.5em;
  line-height: 1.5em;
  border-radius: 100%;
  color: #fff;
  text-align: center;
  box-shadow: 0 0 0 3px #fff;
}

.circle:after {
  content: " ";
  position: absolute;
  display: block;
  right: 60%;
  bottom: 1px;
  left: 50%;
  height: 200%;
  width: 1px;
  transform: scale(1, 2);
  transform-origin: 50% -100%;
  background-color: rgba(0, 0, 0, 0.25);
}

/* Vertical Line */
.milestone:after {
  content: " ";
  position: absolute;
  display: block;
  top: 1px;
  right: 50%;
  bottom: 1px;
  left: 50%;
  height: 100%;
  width: 1px;
  transform: scale(1, 2);
  transform-origin: 50% -100%;
  background-color: rgba(0, 0, 0, 0.25);
}
.milestone i {
  font-size: 16px;
}

.end:after {
  height: 0%;
}

.step:last-child .milestone:after,
.step:last-child .circle:after {
  display: none;
}

/* Stepper Titles */
.big-step .title {
  font-family: "Open Sans", "sans-serif";
  font-weight: 600;
  line-height: 1.5em;
  font-size: 0.85em;
}
.big-step.step-active {
  color: #4285f4;
}
.big-step .step-completed {
  color: #fb6340;
}
.base-step .title {
  font-size: 0.8em;
  margin-top: -5px;
}

.caption {
  font-size: 0.8em;
}
</style>
